



























































































































































import axios from 'axios'
import {Mixins, Component} from "vue-property-decorator";
import att_mixins from "@/mixins/att";

@Component
export default class role_group extends Mixins(att_mixins) {
    columns = [
        {
            title: 'ID',
            key: 'ID',
            width: 85,
            sortable: true
        },
        {
            title: '权限组',
            key: 'Name',
            sortable: true
        },
        {
            title: '操作',
            key: 'action',
            align: 'center',
            slot: 'action'
        }
    ];
    addAuthGroupForm = {
        group_name: ''
    };
    permission = {
        ddl: '0',
        ddl_source: [],
        dml: '0',
        dml_source: [],
        query: '0',
        query_source: [],
        user: '0',
        base: '0',
        auditor: []
    } as any;
    connectionList = {
        connection: [],
        person: [],
        query: []
    } as any;

    indeterminate = {
        ddl: true,
        dml: true,
        query: true,
        person: true
    } as any;

    checkAll = {
        ddl: false,
        dml: false,
        query: false,
        person: false
    } as any;


    addAuthGroupModal = false;

    isReadOnly = false;

    saveAddGroup() {
      if (this.addAuthGroupForm.group_name === '') {
        this.$Message.error("权限组名称不可为空！")
        return
      }
        axios.post(`${this.$config.url}/group/update`, {
            'username': this.addAuthGroupForm.group_name,
            'permission': this.permission,
            'tp': 1
        })
            .then(res => {
                this.$config.notice(res.data);
                this.current = 1;
                this.current_page()
            })
            .catch(error => {
                this.$config.err_notice(this, error)
            });
        this.addAuthGroupModal = false
    }

    current_page(vl = 1) {
        axios.get(`${this.$config.url}/group?page=${vl}&con=${JSON.stringify(this.query)}&tp=1`)
            .then(res => {
                this.table_data = res.data.group_list;
                this.page_number = parseInt(res.data.page);
                this.connectionList.connection = res.data.source;
                this.connectionList.query = res.data.query;
                this.connectionList.person = res.data.audit;
            })
            .catch(error => {
                this.$config.err_notice(this, error)
            })
    }

    deleteAuthGroup(vl: { Name: string; }) {
        axios.delete(`${this.$config.url}/group/del/${vl.Name}`)
            .then(res => {
                this.$config.notice(res.data);
                this.current_page()
            })
            .catch(err => this.$config.err_notice(this, err))
    }

    queryData() {
        this.query.valve = true;
        this.current_page()
    }

    queryCancel() {
        this.$config.clearObj(this.formItem);
        this.current_page()
    }

    batchOpen() {
        this.addAuthGroupModal = true;
        this.isReadOnly = false;
        this.addAuthGroupForm.group_name = '';
        this.permission = this.$config.clearOption(this.permission);
        this.current_page();
    }

    editAuthGroup(vl: { Name: string; Permissions: any; }) {
        this.isReadOnly = true;
        this.addAuthGroupModal = true;
        this.addAuthGroupForm.group_name = vl.Name;
        this.permission = vl.Permissions;
    }

    ddlCheckAll(name: string | number, indeterminate: string | number, ty: string) {
        if (this.indeterminate[indeterminate]) {
            this.checkAll[indeterminate] = false;
        } else {
            this.checkAll[indeterminate] = !this.checkAll[indeterminate];
        }
        this.indeterminate[indeterminate] = false;
        if (this.checkAll[indeterminate]) {
            if (ty === 'person') {
                this.permission[name] = this.connectionList[ty].map((vl: { Username: string; }) => vl.Username);
            } else {
                this.permission[name] = this.connectionList[ty].map((vl: { Source: string; }) => vl.Source)
            }
        } else {
            this.permission[name] = []
        }
    }

    mounted() {
        this.current_page()
    }
}
